<template>
    <v-card>
        <div class="TrainingCard">
            <div v-for="(field, id) in fields" :key="id" class="TrainingCard__field-wrap">
                <Field v-if="field.id"
                       :field-id="field.id"
                       :card-namespace="namespace"
                       :key="namespace+field.id+id"
                />
            </div>
        </div>
    </v-card>
</template>

<script>
import Field from '@/views/Public/Field/Field';
import store from '@/store/store';
//import HelpModal from '@/components/HelpModal';
export default {
    components: {
        // HelpModal,
        Field
    },

    computed: {
        helpTitle() {
            return store.state[this.namespace].helpTitle;
        },

        helpText() {
            return store.state[this.namespace].helpText;
        }
    },

    props: [
        'name',
        'cardHasData',
        'loaded',
        'namespace',
        'fields',
    ],
};
</script>

<style lang="scss">
    .TrainingCard {
        display: flex;
        flex-flow: row wrap;
        flex: 0 0 100%;
        width: 100%;
    }

    .TrainingCard__field-wrap {
        display: flex;
        flex-flow: row wrap;
        flex: 0 0 100%;
        width: 100%;
    }
</style>

